import { QueryClient } from 'react-query';
import { ApiError } from '../services/ApiService/errors/ApiError';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: ApiError) => {
        if (error.status === 403) {
          return false;
        }

        // Retry up to 3 times if the HTTP status is not a 403
        return failureCount < 3;
      },
    },
  },
});
